import React, { useEffect } from 'react'

import { LoadingSpinner } from '@elo-kit/components/loading-spinner/LoadingSpinner'
import LoadMoreButton from 'shared/components/community/components/load-more-button/LoadMoreButton'

import { withStores } from 'utils/helpers.utils'

import MembersListItem from '../components/member/MemberItem'

const MembersList = ({ communityId, communityMembersStore, handleFilterByUser, isPayerCabinet }) => {
  const {
    list,
    hasMoreMembers,
    loadingMember: { mute: muteInProgress },
    membersAreLoading,
  } = communityMembersStore

  useEffect(() => {
    if (list.length === 0) {
      communityMembersStore.fetchMore({ communityId })
    }

    return () => {
      communityMembersStore.resetList()
    }
  }, [])

  const handleMuteUnmute = async (userId, isMuted) => {
    await communityMembersStore.updateItemInList({ communityId, id: userId, muted: !isMuted })
  }

  const handleLoadMoreMembers = async () => {
    await communityMembersStore.fetchMore({ communityId: communityId })
  }

  return (
    <div className='members-list'>
      {list.length === 0 && membersAreLoading && <LoadingSpinner className='loading-spinner__medium-container' />}
      {list.map((member, idx) => (
        <MembersListItem
          key={idx}
          member={member}
          handleMuteUnmute={handleMuteUnmute}
          isLoading={muteInProgress.includes(member.id)}
          isPayerCabinet={isPayerCabinet}
          handleFilterByUser={handleFilterByUser}
        />
      ))}
      {hasMoreMembers && (
        <LoadMoreButton onClick={handleLoadMoreMembers} isLoading={membersAreLoading}>
          {I18n.t('react.shared.community.button.load_more_members')}
        </LoadMoreButton>
      )}
    </div>
  )
}

const stores = ['communityMembersStore']
export default withStores(stores, MembersList)
